import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { EndpointService, HttpErrorHandlingService } from "@app/core";

@Injectable()
export class HistoryTaskDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService,
    private hehs: HttpErrorHandlingService
  ) {}

  /**
   *Obtiene las dependencias del sistema
   *
   * @return {*}  {Observable<any>}
   * @memberof RadicationDocsDataService
   */
  getHistory(task_id: number): Promise<any> {
    return new Promise((resolve) => {
      this.http
        // .post<any>("https://6d796566-01de-4c35-9fcc-cf67e4a4c068.mock.pstmn.io/task_reassign_history/1/", [task_id])
        // Se genera la consulta a la api
        .get<any>(this.api.get("reassigmentResponsible", [task_id]))
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            // console.log(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/history-task/shared/history-task.data.service.ts